import React from 'react';
import _ from 'lodash';
import { Switch, withRouter } from 'react-router-dom';
import routes from './routes';

const renderRoutes = () =>
  _.map(routes, ({ route: RouteComponent, ...props }, i) => <RouteComponent {...props} key={i} />);

const Routes = () => <Switch>{renderRoutes()}</Switch>;

export default withRouter(Routes);
